<!-- Validation Trigger -->
<input style="display: none" type="submit" form="filterForm" #validationTrigger>

<!-- Table -->
<form id="filterForm">
    <mat-table [dataSource]="tableData">

        <!-- Selector -->
        <ng-container matColumnDef='selector'>
            <mat-header-cell *matHeaderCellDef translate>
                <!-- DELIBERATELY LEFT BLANK -->
            </mat-header-cell>
            <mat-cell *matCellDef="let filter; let i = index;">
                <tyl-checkbox *ngIf="filter.field && filter.field.IsDefaultFilterField && forStudentSearch"
                    [disabled]="filter.disableEdit" [checked]="filter.UseFilterForStudentSearch"
                    (checkedChange)="updateFilter(filter, 'UseFilterForStudentSearch', $event)"
                    id="filter{{i}}StudentFilterCheckbox"></tyl-checkbox>
                <tyl-checkbox *ngIf="filter.field && filter.field.IsDefaultFilterField && forCourseSearch"
                    [disabled]="filter.disableEdit" [checked]="filter.UseFilterForCourseSearch"
                    (checkedChange)="updateFilter(filter, 'UseFilterForCourseSearch', $event)"
                    id="filter{{i}}CourseFilterCheckbox"></tyl-checkbox>
                <tyl-checkbox *ngIf="filter.field && filter.field.IsDefaultFilterField && forStaffSearch"
                    [disabled]="filter.disableEdit" [checked]="filter.UseFilterForStaffSearch"
                    (checkedChange)="updateFilter(filter, 'UseFilterForStaffSearch', $event)"
                    id="filter{{i}}StaffFilterCheckbox"></tyl-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Field Column -->
        <ng-container matColumnDef='field'>
            <mat-header-cell *matHeaderCellDef translate>
                Field
            </mat-header-cell>
            <mat-cell *matCellDef="let filter">
                <data-query-field-label *ngIf="filter.field && !forStudentSearch && !forCourseSearch && !forStaffSearch"
                    [field]="filter.field" style="width: 100%;"></data-query-field-label>
                <span *ngIf="(forStudentSearch || forCourseSearch || forStaffSearch) && filter.field">
                    {{filter.field.Alias}}
                </span>
            </mat-cell>
        </ng-container>

        <!-- Operator Column -->
        <ng-container matColumnDef='operator'>
            <mat-header-cell *matHeaderCellDef translate>
                Operator
            </mat-header-cell>
            <mat-cell *matCellDef="let filter; let i = index;">

                <!-- Operator Selection -->
                <tyl-form-field *ngIf="filter.field && !disableOptions(filter, true)" [hideRequiredMarker]="true">
                    <mat-select id="filter{{i}}Operator" name="filter{{i}}Operator" [ngModel]="filter.Operator"
                        (ngModelChange)="updateFilter(filter, 'Operator', $event)" [required]="true">
                        <mat-option *ngFor="let operator of filter.getFilterOperators()" [value]="operator">
                            {{operator}}
                        </mat-option>
                    </mat-select>
                </tyl-form-field>

                <!-- Operator Indicator -->
                <span *ngIf="filter.field && disableOptions(filter, true)">
                    =
                </span>
            </mat-cell>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef='value'>
            <mat-header-cell *matHeaderCellDef translate>
                Value
            </mat-header-cell>
            <mat-cell *matCellDef="let filter; let i = index;">

                <!-- Value Selection -->
                <ng-container *ngIf="filter.field && !disableOptions(filter, false)">

                    <!-- Filter Type 0 (Primitive) -->
                    <ng-container *ngIf="filter.field.FilterType == 0">

                        <!-- For non-bit data -->
                        <ng-container *ngIf="filter.field.DataType.toLowerCase() != 'bit'">

                            <!-- Value 1 -->
                            <tyl-form-field [ngStyle]="{
									'width': filter.Operator == 'Between' ? 'calc(47.5% - 15px)' : '95%'
								}" [fullWidth]="true" errorMessage="Entry must be numeric">
                                <input *ngIf="filter.numericType" matInput id="filter{{i}}NumericValue1"
                                    name="filter{{i}}NumericValue1" [ngModel]="filter.Value"
                                    (ngModelChange)="updateFilter(filter, 'Value', $event)" appDecimalFormatValidator
                                    [allowNegativeValue]="true"
                                    [disabled]="filter.disabled() || checkDisabledField(filter.field)">
                                <input *ngIf="!filter.numericType" matInput id="filter{{i}}Value1"
                                    name="filter{{i}}NumericValue1" [ngModel]="filter.Value"
                                    (ngModelChange)="updateFilter(filter, 'Value', $event)"
                                    [pattern]="filter.numericType ? '[0-9]*' : '.*'"
                                    [disabled]="filter.disabled() || checkDisabledField(filter.field)">

                            </tyl-form-field>

                            <!-- Value 2 -->
                            <ng-container *ngIf="filter.Operator == 'Between'">
                                <span translate>&nbsp;and&nbsp;</span>
                                <tyl-form-field style="width: calc(47.5% - 15px)" [fullWidth]="true"
                                    errorMessage="Entry must be numeric">
                                    <input matInput id="filter{{i}}NumericValue2" name="filter{{i}}NumericValue2"
                                        *ngIf="filter.numericType" [ngModel]="filter.Value2"
                                        (ngModelChange)="updateFilter(filter, 'Value2', $event)"
                                        appDecimalFormatValidator [allowNegativeValue]="true"
                                        [disabled]="filter.disabled() || checkDisabledField(filter.field)">
                                    <input matInput id="filter{{i}}Value2" name="filter{{i}}NumericValue2"
                                        *ngIf="!filter.numericType" [ngModel]="filter.Value2"
                                        (ngModelChange)="updateFilter(filter, 'Value2', $event)"
                                        [pattern]="filter.numericType ? '[0-9]*' : '.*'"
                                        [disabled]="filter.disabled() || checkDisabledField(filter.field)">
                                </tyl-form-field>
                            </ng-container>
                        </ng-container>

                        <!-- For bit data -->
                        <ng-container *ngIf="filter.field.DataType.toLowerCase() == 'bit'">

                            <!-- Value 1 -->
                            <tyl-form-field [hideRequiredMarker]="true" [fullWidth]="true">
                                <mat-select id="filter{{i}}BitValue" name="filter{{i}}BitValue" [ngModel]="filter.Value"
                                    (ngModelChange)="updateFilter(filter, 'Value', $event)"
                                    [disabled]="filter.disabled() || checkDisabledField(filter.field)"
                                    [required]="!filter.field || !filter.field.IsDefaultFilterField || (!forCourseSearch && !forStudentSearch && !forCourseSearch)">
                                    <mat-option value="true">
                                        <!-- NOTE: These are deliberately strings -->
                                        Yes
                                    </mat-option>
                                    <mat-option value="false">
                                        <!-- NOTE: These are deliberately strings -->
                                        No
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                        </ng-container>
                    </ng-container>

                    <!-- Filter Type 1 (Date) -->
                    <div *ngIf="filter.field.FilterType == 1" style="display: flex; width: 100%; align-items: center;">

                        <!-- Value 1 -->
                        <div style="align-items: center;" [ngStyle]="{'width':filter.Operator == 'Between' ? '220px' : '100%'}">
                            <tyl-datepicker [ngStyle]="{'width':filter.Operator == 'Between' ? '50px' : '50%'}" id="filter{{i}}DateValue" [value]="filter.dateValue"
                                (valueChange)="updateFilter(filter, 'dateValue', $event)"
                                [disabled]="filter.disabled() || checkDisabledField(filter.field) || filter.UseCurrentDate1">
                            </tyl-datepicker>
                            <span style="margin-left: 80px;">
                                (<tyl-checkbox [disabled]="filter.disabled()" id="filter{{i}}UseCurrentDate1" style="margin-left: -6px;"
                                    [(checked)]="filter.UseCurrentDate1" (click)="filter.disabled() == false && setCurrentDate1(filter)">Current
                                </tyl-checkbox>)
                            </span>
                        </div>

                        <!-- Between "And" -->
                        <span *ngIf="filter.Operator == 'Between'" style="flex: 0 0" translate>&nbsp;and&nbsp;</span>

                        <!-- Value 2 -->
                        <div *ngIf="filter.Operator == 'Between'" 
                            style="align-items: center;" 
                            [ngStyle]="{'width':filter.Operator == 'Between' ? '245px' : '100%'}">                          
                            <tyl-datepicker [ngStyle]="{'width':filter.Operator == 'Between' ? '50px' : ''}" id="filter{{i}}DateValue2"
                                [value]="filter.dateValue2"
                                (valueChange)="updateFilter(filter, 'dateValue2', $event)"
                                [disabled]="filter.disabled() || checkDisabledField(filter.field) || filter.UseCurrentDate2">
                            </tyl-datepicker>
                            <span style="margin-left: 80px;">
                                (<tyl-checkbox style="margin-left: -6px;"
                                    [disabled]="filter.disabled()" 
                                    id="filter{{i}}UseCurrentDate2"
                                    [(checked)]="filter.UseCurrentDate2"
                                    (click)="filter.disabled() == false && setCurrentDate2(filter)">
                                    Current
                                </tyl-checkbox>)
                            </span>
                        </div>
                    </div>

                    <!-- Filter Type 3 (Enumeration) -->
                    <ng-container *ngIf="filter.field.FilterType == 3">

                        <!-- Selection -->
                        <tyl-form-field *ngIf="filter.Operator != 'Contains' && filter.Operator != 'Starts With'"
                            [hideRequiredMarker]="true" [fullWidth]="true">
                            <mat-select id="filter{{i}}EnumerationValue" name="filter{{i}}EnumerationValue"
                                [ngModel]="filter.Value" (ngModelChange)="updateFilter(filter, 'Value', $event)"
                                [disabled]="filter.disabled() || checkDisabledField(filter.field)"
                                [required]="(!filter.field || !filter.field.IsDefaultFilterField || (!forCourseSearch && !forStudentSearch && !forStaffSearch)) && (filter.disabled() == false && checkDisabledField(filter.field) == false)">
                                <mat-option *ngFor="let option of filter.FilterOptions"
                                    [value]="filter.useCodeDescription(V10) ? option.CodeDescription : option.Code"
                                    [disabled]="filter.disabled() || checkDisabledField(filter.field)">
                                    {{option.Code}}
                                    {{option.Code && option.CodeDescription ? ' - ' : ''}}
                                    {{option.CodeDescription}}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>

                        <!-- Input for Contains and Starts With -->
                        <tyl-form-field *ngIf="filter.Operator == 'Contains' || filter.Operator == 'Starts With'"
                            errorMessage="Entry must be numeric" [fullWidth]="true">
                            <input matInput id="filter{{i}}NumericValue" name="filter{{i}}NumericValue"
                                [(ngModel)]="filter.Value" (ngModelChange)="updateFilter(filter, 'Value', $event)"
                                [disabled]="filter.disabled() || checkDisabledField(filter.field)"
                                [pattern]="filter.numericType ? '[0-9]*' : '.*'">
                        </tyl-form-field>
                    </ng-container>
                </ng-container>

                <!-- Value Indicator -->
                <ng-container *ngIf="filter.field && disableOptions(filter, false)">
                    <!-- Filter Type 3 (Enumeration) -->
                    <ng-container
                        *ngIf="filter.field.FieldName == 'StudentsListfilter' || filter.field.FieldName == 'StudentsTeamfilter'">
                        <!-- Selection -->
                        <tyl-form-field *ngIf="filter.Operator != 'Contains' && filter.Operator != 'Starts With'"
                            [hideRequiredMarker]="true" [fullWidth]="true">
                            <mat-select id="filter{{i}}EnumerationValue" name="filter{{i}}EnumerationValue"
                                [ngModel]="filter.Value" (ngModelChange)="updateFilter(filter, 'Value', $event)"
                                [disabled]="filter.disabled() || checkDisabledField(filter.field)"
                                [required]="!filter.field || !filter.field.IsDefaultFilterField || (!forCourseSearch && !forStudentSearch && !forStaffSearch)">
                                <mat-option *ngFor="let option of filter.FilterOptions" [value]="option.Id"
                                    [disabled]="filter.disabled() || checkDisabledField(filter.field)">
                                    {{option.Code}}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </ng-container>

                    <span
                        *ngIf="filter.field.FieldName != 'StudentsListfilter' && filter.field.FieldName != 'StudentsTeamfilter'">{{filter.Value}}</span>
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Apply to All Groups Column -->
        <ng-container matColumnDef='apply-to-all-groups'>
            <mat-header-cell *matHeaderCellDef translate>
                Apply to All Groups
            </mat-header-cell>
            <mat-cell *matCellDef="let filter">
                <tyl-checkbox [disabled]="filter.disableEdit" [checked]="filter.ApplyToAll"
                    (checkedChange)="updateFilter(filter, 'ApplyToAll', $event)"></tyl-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Group Column -->
        <ng-container matColumnDef='group'>
            <mat-header-cell *matHeaderCellDef translate>
                Group
                <button
                    style="color: blue; background-color: white; border: 1px solid blue; border-radius: 5px; margin-bottom: 5px; margin-left: 5px; "
                    id="groupInfo" aria-label="open Group Info" (click)="openGroupMsgClick()">?</button>
            </mat-header-cell>
            <mat-cell *matCellDef="let filter; let i = index;">
                <tyl-form-field *ngIf="filter.field && !filter.ApplyToAll">
                    <input matInput [disabled]="filter.disableEdit" name="filter{{i}}Group" id="filter{{i}}Group"
                        [ngModel]="filter.Group" (ngModelChange)="updateFilter(filter, 'Group', $event)" maxlength="1"
                        validate-filter-group [disabled]="checkDisabledField(filter.field)">
                </tyl-form-field>
            </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef='actions'>
            <mat-header-cell *matHeaderCellDef translate>
                Actions
            </mat-header-cell>
            <mat-cell *matCellDef="let filter">
                <tyl-mat-menu image="actions.png" disabledImage="actions disabled.png" [disabled]="filter.disableEdit"
                    [showLabel]="false" [topMenuItems]="[
						'Duplicate',
						'Delete'
					]" [bottomMenuItems]="(filter.IsStudentFilter ||  filter.IsCourseFilter) ? ['Expand'] : []"
                    (menuClick)="menuItemClick($event)" [data]="filter"></tyl-mat-menu>
            </mat-cell>
        </ng-container>

        <!-- Row Definitions -->
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>
    </mat-table>
</form>
